/* ==========================================================================
   Kurv v2 — Massage Care
   Tryghedskarrusel, indretning af ordreoversigten og skovælgeren.
   Filen indlæses på kurv-siden og — for vælgerens skyld — fra kurv-drawer'en
   på alle andre sider.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Beløb i kundens valuta og sprog (3 299 kr, 299 €)
  function kr(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
    var sprog = document.documentElement.lang || 'da';
    try {
      return new Intl.NumberFormat(sprog, { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(cents / 100));
    } catch (e) {
      return Math.round(cents / 100) + ' ' + cur;
    }
  }

  /* --- Tryghedskarrusel -------------------------------------------------- */
  function startCarousel() {
    var box = document.querySelector('[data-cv2-carousel]');
    if (!box || box.dataset.cv2Running === '1') return;
    var slides = Array.prototype.slice.call(box.querySelectorAll('.cv2-slide'));
    if (slides.length < 2) return;
    box.dataset.cv2Running = '1';
    var wait = parseInt(box.dataset.cv2Interval, 10) || 3000;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, wait);
  }

  /* --- Ret ordreoversigten ind efter tryghedskarrusellen ----------------- */
  function alignSummary() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sec = main.querySelector(':scope > .shopify-section:first-child');
    var target = document.querySelector('.cv2-trust') || document.querySelector('.cart-items');
    if (!sec || !target || window.innerWidth < 990) {
      main.style.removeProperty('--cv2-summary-offset');
      return;
    }
    main.style.setProperty('--cv2-summary-offset', '0px');
    var off = Math.round(target.getBoundingClientRect().top - sec.getBoundingClientRect().top);
    main.style.setProperty('--cv2-summary-offset', Math.max(0, off) + 'px');
  }

  var alignTimer;
  window.addEventListener('resize', function () {
    clearTimeout(alignTimer);
    alignTimer = setTimeout(alignSummary, 120);
  });

  /* --- Skovælger --------------------------------------------------------- */
  var need = 0;
  var chosen = [];
  var draft = {};
  var shoes = [];

  function shoeData() {
    var el = document.getElementById('cv2-shoe-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function colorsOf(shoe) {
    var out = [];
    shoe.variants.forEach(function (v) {
      var hit = out.filter(function (c) { return c.name === v.c; })[0];
      if (!hit) { hit = { name: v.c, sizes: [] }; out.push(hit); }
      hit.sizes.push(v);
    });
    return out;
  }

  function pairsInCart() {
    var el = document.getElementById('cv2-shoe-data');
    return el ? (parseInt(el.dataset.pairs, 10) || 0) : 0;
  }

  function bogoAmount(extraPrices) {
    var units = [];
    shoes.forEach(function (s) {
      for (var i = 0; i < (s.inCart || 0); i++) units.push(s.price);
    });
    (extraPrices || []).forEach(function (p) { units.push(p); });
    units.sort(function (a, b) { return b - a; });
    var amt = 0;
    for (var j = 2; j < units.length; j += 3) amt += units[j];
    return amt;
  }

  function openPicker(single, focusHandle) {
    if (!document.getElementById('cv2-modal')) return;
    shoes = shoeData();
    var pairs = pairsInCart();
    need = single ? 1 : ((3 - pairs % 3) % 3 || 3);
    chosen = [];
    draft = {};

    var title = document.getElementById('cv2-sheet-title');
    var sub = document.getElementById('cv2-sheet-sub');
    if (single) {
      var til3 = (3 - (pairs + 1) % 3) % 3;
      title.textContent = 'Farbe und Größe wählen';
      sub.textContent = til3 === 0
        ? 'Mit diesem Paar haben Sie drei, dann ist das günstigste gratis.'
        : 'Legen Sie danach ' + til3 + ' weitere Paar dazu, dann ist das günstigste der drei gratis.';
    } else {
      title.textContent = need === 1 ? 'Gratis Paar wählen' : need + ' weitere Paar wählen';
      sub.textContent = need === 1
        ? 'Sie haben zwei Paar im Warenkorb. Wählen Sie das letzte, dann ziehen wir den Preis des günstigsten der drei ab.'
        : 'Wählen Sie ' + need + ' Paar. Das günstigste Ihrer drei Paare ist gratis, Sie können Modelle und Farben also frei kombinieren.';
    }

    renderPicks();
    renderSlots();
    document.getElementById('cv2-modal').classList.add('is-open');
    document.body.classList.add('cv2-modal-open');

    if (focusHandle) {
      var el = document.querySelector('.cv2-pick[data-handle="' + focusHandle + '"]');
      if (el) el.scrollIntoView({ block: 'start' });
    }
  }

  function closePicker() {
    var m = document.getElementById('cv2-modal');
    if (m) m.classList.remove('is-open');
    document.body.classList.remove('cv2-modal-open');
  }

  function renderSlots() {
    var html = '';
    for (var i = 0; i < need; i++) {
      var c = chosen[i];
      html += c
        ? '<span class="cv2-slot">' + c.title + ' · ' + c.color + ' / ' + c.size +
          '<button type="button" data-cv2="unslot" data-i="' + i + '" aria-label="Auswahl entfernen">&#215;</button></span>'
        : '<span class="cv2-slot is-empty">' + 'Paar ' + (i + 1) + ': noch nicht gewählt' + '</span>';
    }
    document.getElementById('cv2-slots').innerHTML = html;

    var done = chosen.length === need;
    var ok = document.getElementById('cv2-sheet-ok');
    ok.disabled = !done;
    ok.textContent = done ? need + ' Paar in den Warenkorb' : 'Noch ' + (need - chosen.length) + ' wählen';

    var amt = bogoAmount(chosen.map(function (c) { return c.price; }));
    document.getElementById('cv2-sheet-save').innerHTML = amt
      ? 'Sie sparen <b>' + kr(amt) + '</b><span>Das günstigste Paar wird im Warenkorb abgezogen</span>'
      : '<span>Wählen Sie Ihre Paare, um den Rabatt zu sehen</span>';
  }

  function renderPicks() {
    document.getElementById('cv2-picks').innerHTML = shoes.map(function (s) {
      var d = draft[s.handle] || {};
      var colors = colorsOf(s);
      var sizes = [];
      if (d.color) {
        var hit = colors.filter(function (c) { return c.name === d.color; })[0];
        sizes = hit ? hit.sizes : [];
      }
      return '' +
        '<div class="cv2-pick" data-handle="' + s.handle + '">' +
          '<div class="cv2-pick__top">' +
            (s.image ? '<img src="' + s.image + '" alt="" loading="lazy">' : '') +
            '<div>' +
              '<p class="cv2-pick__name">' + s.title + '</p>' +
              '<p class="cv2-pick__price">' +
                (s.compare > s.price ? '<s>' + kr(s.compare) + '</s>' : '') + kr(s.price) +
              '</p>' +
            '</div>' +
          '</div>' +
          '<p class="cv2-opt-label">' + (s.optionNames[0] || 'Farbe') + '</p>' +
          '<div class="cv2-chips">' + colors.map(function (c) {
            var soldOut = c.sizes.every(function (v) { return !v.a; });
            return '<button type="button" class="cv2-chip" data-cv2="color" data-h="' + s.handle +
                   '" data-v="' + c.name + '" aria-pressed="' + (d.color === c.name) + '"' +
                   (soldOut ? ' disabled title="Ausverkauft"' : '') + '>' + c.name + '</button>';
          }).join('') + '</div>' +
          (d.color
            ? '<p class="cv2-opt-label">' + (s.optionNames[1] || 'Größe') + '</p>' +
              '<div class="cv2-chips cv2-chips--sizes">' + sizes.map(function (v) {
                return '<button type="button" class="cv2-chip" data-cv2="size" data-h="' + s.handle +
                       '" data-v="' + v.s + '" data-id="' + v.id + '" aria-pressed="' + (d.size === v.s) + '"' +
                       (v.a ? '' : ' disabled title="Ausverkauft"') + '>' + v.s + '</button>';
              }).join('') + '</div>'
            : '') +
          '<button type="button" class="cv2-pick__add" data-cv2="pickadd" data-h="' + s.handle + '"' +
            (d.color && d.size && chosen.length < need ? '' : ' disabled') + '>Dieses Paar hinzufügen</button>' +
        '</div>';
    }).join('');
  }

  /* Læg de valgte par i kurven.
     På kurv-siden gen-renderes sektionerne. Alle andre steder er det
     drawer'en der skal opdateres — den lytter selv efter /cart/add. */
  function addChosen() {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var onCartPage = !!(itemsEl && footerEl);

    var ok = document.getElementById('cv2-sheet-ok');
    ok.disabled = true;
    ok.textContent = 'Wird hinzugefügt…';

    var items = chosen.map(function (c) { return { id: c.variantId, quantity: 1 }; });

    if (!onCartPage) {
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { closePicker(); })
        .catch(function () { window.location.reload(); });
      return;
    }

    var ids = [itemsEl.dataset.id, footerEl.dataset.id, 'cart-icon-bubble'];

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ids.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status || !data.sections) { window.location.reload(); return; }
        var parser = new DOMParser();
        function swap(html, hostSel) {
          if (!html) return;
          var host = document.querySelector(hostSel);
          if (!host) return;
          var src = parser.parseFromString(html, 'text/html').querySelector('.js-contents');
          if (src) host.innerHTML = src.innerHTML;
        }
        swap(data.sections[itemsEl.dataset.id], '#main-cart-items .js-contents');
        swap(data.sections[footerEl.dataset.id], '#main-cart-footer .js-contents');

        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections['cart-icon-bubble']) {
          var srcB = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (srcB) bubble.innerHTML = srcB.innerHTML;
        }

        closePicker();
        alignSummary();
        var offer = document.querySelector('.cv2-offer');
        if (offer) offer.scrollIntoView({ block: 'center', behavior: 'smooth' });
      })
      .catch(function () { window.location.reload(); });
  }

  /* --- Hændelser --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cv2]');
    if (!b) return;
    var a = b.dataset.cv2;

    if (a === 'offer') { e.preventDefault(); openPicker(false); return; }
    if (a === 'pickone') { e.preventDefault(); openPicker(true, b.dataset.h); return; }
    if (a === 'close') { closePicker(); return; }
    if (a === 'promo') { e.preventDefault(); applyPromo(); return; }
    if (a === 'color') { draft[b.dataset.h] = { color: b.dataset.v, size: null }; renderPicks(); return; }
    if (a === 'size') {
      draft[b.dataset.h].size = b.dataset.v;
      draft[b.dataset.h].variantId = b.dataset.id;
      renderPicks();
      return;
    }
    if (a === 'pickadd') {
      var s = shoes.filter(function (x) { return x.handle === b.dataset.h; })[0];
      var d = draft[b.dataset.h];
      chosen.push({ handle: s.handle, title: s.title, price: s.price, color: d.color, size: d.size, variantId: d.variantId });
      draft[b.dataset.h] = {};
      renderPicks();
      renderSlots();
      return;
    }
    if (a === 'unslot') { chosen.splice(Number(b.dataset.i), 1); renderPicks(); renderSlots(); return; }
    if (a === 'confirm') { addChosen(); return; }
  });

  /* --- Rabatkode --------------------------------------------------------- */
  function applyPromo() {
    var input = document.getElementById('cv2-promo-input');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    window.location.href = root + 'discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(window.location.pathname);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.id === 'cv2-promo-input') {
      e.preventDefault();
      applyPromo();
      return;
    }
    var m = document.getElementById('cv2-modal');
    if (e.key === 'Escape' && m && m.classList.contains('is-open')) closePicker();
  });

  function init() { startCarousel(); alignSummary(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', alignSummary);
})();
